export default __webpack_public_path__ + "static/media/Traveling.014f3faa.svg";